angular.module("kitstajm").factory("Slack", function ($resource) {
  return $resource(
    "api/slack",
    {},
    {
      send: { method: "POST" },
    }
  );
});
